// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { GiftingProposalProjectionFragment } from './GiftingProposalProjection.fragment.generated';
import { gql } from '@apollo/client';
import { GiftingProposalProjectionFragmentDoc } from './GiftingProposalProjection.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProjectionsForProposalQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProposalWhereInput>;
}>;


export type GetProjectionsForProposalQuery = { __typename?: 'Query', proposals: { __typename?: 'ProposalConnection', edges?: Array<{ __typename?: 'ProposalEdge', node?: { __typename?: 'Proposal', id: string, giftingProposal?: { __typename?: 'GiftingProposal', id: string, giftingScenarios?: Array<{ __typename?: 'GiftingProposalScenario', id: string, isBaseline: boolean, isDefault: boolean, order: number, displayName: string, projections: (
              { __typename?: 'GiftingProposalProjections' }
              & GiftingProposalProjectionFragment
            ) }> | null } | null } | null } | null> | null } };

export const Operations = {
  Query: {
    GetProjectionsForProposal: 'GetProjectionsForProposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetProjectionsForProposalDocument = gql`
    query GetProjectionsForProposal($where: ProposalWhereInput) {
  proposals(where: $where) {
    edges {
      node {
        id
        giftingProposal {
          id
          giftingScenarios {
            id
            isBaseline @client
            isDefault
            order
            displayName
            projections {
              ...GiftingProposalProjection
            }
          }
        }
      }
    }
  }
}
    ${GiftingProposalProjectionFragmentDoc}`;

/**
 * __useGetProjectionsForProposalQuery__
 *
 * To run a query within a React component, call `useGetProjectionsForProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectionsForProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectionsForProposalQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetProjectionsForProposalQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectionsForProposalQuery, GetProjectionsForProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectionsForProposalQuery, GetProjectionsForProposalQueryVariables>(GetProjectionsForProposalDocument, withFetchPolicyContext(options));
      }
export function useGetProjectionsForProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectionsForProposalQuery, GetProjectionsForProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectionsForProposalQuery, GetProjectionsForProposalQueryVariables>(GetProjectionsForProposalDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetProjectionsForProposalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectionsForProposalQuery, GetProjectionsForProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectionsForProposalQuery, GetProjectionsForProposalQueryVariables>(GetProjectionsForProposalDocument, withFetchPolicyContext(options));
        }
export type GetProjectionsForProposalQueryHookResult = ReturnType<typeof useGetProjectionsForProposalQuery>;
export type GetProjectionsForProposalLazyQueryHookResult = ReturnType<typeof useGetProjectionsForProposalLazyQuery>;
export type GetProjectionsForProposalSuspenseQueryHookResult = ReturnType<typeof useGetProjectionsForProposalSuspenseQuery>;
export type GetProjectionsForProposalQueryResult = Apollo.QueryResult<GetProjectionsForProposalQuery, GetProjectionsForProposalQueryVariables>;